import { NotificationDeadline } from 'api/types/UserEmployeeInfo';
import { useDeadlines } from 'store/deadlineContext';

export type CheckColorFn = (
  incomingDate?: string | null,
  group?: string,
  name?: string
) => 'green' | 'yellow' | 'red' | 'black';

export default function useCheckColor(): CheckColorFn {
  const { deadlines } = useDeadlines();

  const checkColor = (
    incomingDate?: string | null,
    group?: string,
    name?: string
  ) => {
    if (
      deadlines &&
      deadlines !== null &&
      incomingDate !== undefined &&
      incomingDate !== '' &&
      incomingDate !== null
    ) {
      const dataNow = new Date();
      dataNow.setHours(0);
      dataNow.setMinutes(0);
      dataNow.setSeconds(0);

      const data = new Date(incomingDate);
      data.setHours(0);

      const numberOfDays: number = Math.round(
        (data.valueOf() - dataNow.valueOf()) / (1000 * 60 * 60 * 24)
      );

      const cfg: NotificationDeadline | undefined =
        group && name
          ? deadlines.find((f) => f.group === group && f.name === name)
          : undefined;

      if (cfg) {
        const warnYellow = cfg?.warnYellow;
        const warnRed = cfg?.warnRed;

        if (numberOfDays > warnRed && numberOfDays <= warnYellow) {
          return 'yellow';
        }
        if (numberOfDays <= warnRed && numberOfDays >= 0) {
          return 'red';
        }
        if (numberOfDays < 0) {
          return 'black';
        }
      }
    }
    return 'green';
  };

  return checkColor;
}
